/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useState, useContext, useEffect } from "react";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import firebase from "firebase/app";
import { useHistory } from "react-router-dom";
import "firebase/messaging";
import song from "../../../images/vikki.wav";
import useSound from "use-sound";
import icon from "../../../images/logo.png";
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}
const SideBar = () => {
  const [plays, { stop }] = useSound(song);
  const history = useHistory();
  // const messaging = firebase.messaging();
  var userDetails = JSON.parse(localStorage.getItem("goSampleUserDetails"));
  const [appliedStatus, setAppliedStatus] = useState(false);
  const [riderCount, setRiderCount] = useState("");
  //const[pathData,setPathData]=useState(path)
  const [permission, setPermission] = useState("");
  /// Path
  let path = window.location.pathname;
  var realPath = path;
  path = path.split("/");
  path = path[path.length - 1];
  let paths = path[path.length - 2];

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  let staff = ["all-staff", "all-roles", "new-staff", "add-roles"],
   
    rider = [
      "edit-rider",
      "riders",
      "rider-applied",
      "blocked-rider",
      "Training",
      "rejected-riders",
      "Rider-View",
    ],
 
    order = ["all-orders", "Order-Ratings"],
 
   
    diagnostics = [
      "Packages",
      "Package Banner",
      "Tests",
      "Package Category",
      "Main Category",
      "Health Centers",
      "Sub Tests",
      "Rider-Register",
      "Delivery Charge",
    ];
  useEffect(() => {
    getData();
  }, []);
  if (firebase.messaging.isSupported()) {
    firebase.messaging().onMessage((notification) => {
      plays();
      if (notification.data.title === "Rider") {
        swal({
          title: `${notification.data.title}`,
          text: `${notification.data.body}`,
          type: "danger",
          timer: 12000,
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
        }).then(function (isConfirm) {
          if (isConfirm) {
            stop();
            history.push("/rider-applied");
          }
        });
      } else if (notification.data.title === "User") {
        swal({
          title: `${notification.data.title}`,
          text: `${notification.data.body}`,
          type: "danger",
          timer: 12000,
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
        }).then(function (isConfirm) {
          if (isConfirm) {
            stop();
            history.push(`/show-order/${notification.data.orderId}`);
          }
        });
      } else if (notification.data.title === "Airport") {
        swal({
          title: `${notification.data.title}`,
          text: `${notification.data.body}`,
          type: "danger",
          timer: 12000,
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
        }).then(function (isConfirm) {
          if (isConfirm) {
            stop();
            history.push(`/AirPort-Orders`);
          }
        });
      }
    });
  }

  function getData() {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    var handleheartBlast = document.querySelector(".heart");
    function heartBlast() {
      return handleheartBlast.classList.toggle("heart-blast");
    }

    handleheartBlast.addEventListener("click", heartBlast);
    axios.get(`${Baseurl.baseurl}/roles/get-roles`).then((response) => {
      response.data.details.map((val) => {
        if (val.Title === userDetails.staff.Role) {
          setPermission(val.Permissions);
          localStorage.setItem("permissions", JSON.stringify(val.Permissions));
          getApliedRider(val.Permissions);
        }
      });
    });
  }
  function getApliedRider(val) {
    axios
      .get(Baseurl.baseurl + "/rider/get-all-not-assigned-riders")
      .then((response) => {
        if (response.data.riders) {
          setRiderCount(response.data.riders.length);
          if (val.includes("Riders Applied")) {
            setAppliedStatus(true);
            swal({
              title: "Rider Applied?",
              text: `you got ${response.data.riders.length} applied riders`,
              type: "danger",
              timer: 1500,
              showCancelButton: true,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Yes, delete it!",
              closeOnConfirm: false,
            });
          }
        } else {
          //callAudio()
        }
      });
  }

  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? ""
          : ""
      }`}
    >
      {/* <!-- Add Project --> */}

      <PerfectScrollbar className="deznav-scroll">
        {permission && (
          <MM className="metismenu" id="menu">
            {permission.includes("Dashboard") && (
              <li className={`${path === "" ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  <i className="flaticon-047-home"></i>
                  <span className="nav-text">Dashboard</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      className={`${path === "/" ? "mm-active" : ""}`}
                      to="/"
                    >
                      Dashboard
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          
            {
            permission.includes("Health Centers") 
            ? (
              <li
                className={`${diagnostics.includes(path) ? "mm-active" : ""}`}
              >
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img
                      height={26}
                      width={26}
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAADt0lEQVR4nO1bPWgUQRRejYraSKwEsRKsTLBVtFD8aRSrCFpFDApaqGChIlwsFAuDwdy8c+ad+94JabYRbLQR0SB2gqj4U/iHkk4N2vh7Mrm5yyX3k7ns7rl7mQ+WhN23b9588+Z7M7t7HiA/BORiqEPRxIj0e7w2QSD36jZDx4005oV3wkWB/LXdBOg2o4jdq/wzz+AIQJcBxf86BYTvrwHlb8nKwuYs0ap5kQGZTGYhIA8Ixc9rhFTRY0D/QLFYXNCRBACMdgvku1Ul6LMuwQL5ESB9myqpfHNoKFjWUQRkMvcW6ZprOvgpp3hfEARd5etEtDSHfKRS2hTfijsT2kqAyPOp0nqB3udyvLqRnV5LlEnIKurvCAKCIOgCxeOlkfW3zWYvFB0qaQK/9DqBgGv5wkYjck9t7KWUi0HxF33PiCqsSz0BWUX9ZkSv295TEUtV2J16AgB5wLSRs75H8e2SDhT2pp8AWdhuNkwPbOy1+oPiD0YIN6SeACnlclD0XSj6bTOnc+jvMKVwXC+cOqIMAtJwOQuCIFjS0A5GuwHplSHgXLwxlQlQNKFrb5yNSSlXCOS3pY7RfSl57Uwbne66UpQrhl4cxRlTpd8j0u+B/I31cTVUKmuFXVoEqx6g/BRId4TiywL5is4MQP5TtUweEnneqe+NK664+z2JrOL9euk79ydN9BHy1OelEaD4/NQGh57okQakS5bHMCA9q9ognfXSBMhTn5nLPwTywbn40OVQyMJRQPolFP0V6O/x0oCM3vkpfmdG73BYf1nkk0Y3XsdZFiODyPNWE/CLKLa0k5sppDeTPqW/yUs6hOTjZvSvRuWzUkEUHfOSDlCcMQo+GJVP7cuIYcZLOoQJtpoAUHRRIF2w9THTvp7PxELUCVaruF7oWPuYYd9WAmDau0Iaa/V63Qyos99o5memfTMCwsZbg8rDywZb2Nmu2xPQ2E9rBISLN3LYEtAMrRCQOAhHALkMgDRNAWj6hciUatra2UyB+r6mtTUrAZHFDVUqWbsfn1JNWzs7Amp9TW/LhoBo444MTgTRieCgrQiW5mfd1Vua1wF8xgjMaQsCrM7X85lYIOJKUHRC/42KgHo+UwUISUDqAY4AdhkASZ0CArk37u98kzgFKv2GNrwcTSIBlX5DOxpLIgHlNsARwC4DwE0BdhrgtUNwQp6PJSZwGsBOA8BpADsN8NohOCHPxxITOA1gpwHgNIDj/lh6rNG7+1bOx6oBMC9/Pc6agMbvzmyPtP56XGfZP2JgMRRnRt1vAAAAAElFTkSuQmCC"
                    />
                  </i>
                  <span className="nav-text">Diagnostics</span>
                </Link>
                <ul>
                  {permission.includes("Health Centers") && (
                    <li>
                      <Link
                        className={`${
                          path === "Health-Center" ? "mm-active" : ""
                        }`}
                        to="/Health-Center"
                      >
                        Health Centers
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            ) : null}
            {(permission.includes("Riders") ||
            
              permission.includes("Blocked Riders") ||
             
              permission.includes("Rider Map View")) && (
              <li
                className={`${
                  rider.includes(path) ||
                  realPath.includes("edit-rider") ||
                  realPath.includes("rider-details")
                    ? "mm-active"
                    : ""
                }`}
              >
                <Link className="has-arrow ai-icon" to="#">
                  {" "}
                  <i>
                    {" "}
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACgklEQVRIie2WT2gTQRjF3zeNzVobsJUKoig9SQ1IK5tLG9HWQhVFe6roQTx5LSKIiCKiUEQoXgRPXkRBQTyKJy+h1mQ2erDiQRLUo1qlwZUGO8+DG9gs2Wbzp576Tt+8ecxvZneGGWBd/0lSLzA3N9cbj8cPkBwhmRSRfgB9ALoBrAD4CuANgBflcvnx8PDwYtNgkiqfz58wxpwTkXEAsYgLcUneXV5evpFOp0sNgbXWkwBuAkhGhNXSJwAnbdt+HRZQNbzpFqEAsAvAS8dxDkcGk7zeIrSijSSfZrPZwUhgpVS8TWAA6FJKPdJad9UFk7zSRjAADAC4GjSrNlcul9stIh/aDAaAXwC22rbtVoyqFYvI5BpAAWCTiEz4jeD5PNTkwDO2bV+u1ZHL5c6LyCzJ4wCeVfzgP94TlWSMGSGZ9ppnw3JKqVdeubfKD+S2RAWLiH9/bAjLdXR0fPHKnX4/+KnZADjjq++H5VzXXezs7ASAhN8PrvhHVLAPmltaWroWIbqyGvh7o2CSqUQi8V5rPZ3JZBLBfsuyemqNHTxObxsFe+oHcMeyrM+O49yan5/f4ZvYNq/8FgoGkEFr2kzyYiwWK2itH2qt9xljBgFARN6FgpVSTwD8bhEO/NvlpwE4InLb86quyCrw0NDQTxG51wawXz0AQPJUKBgALMu6BGAWwKoviCbUuyo4mUyWbdu+UCgUekTE9u5nB4BphUpyxt+u+9irKJ/P9xljDpIcF5GjALY3wP1YKpUGRkdH/zQMDiqbzSaVUsdEZJzkfgChDwiSZ1Kp1AO/1zTYr4WFhW7Xdce8q29CRJ4bYzpF5AjJYrFYHJuamlqpO9C61kJ/AcA70uVGhXVbAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">
                    Technicians{" "}
                    {appliedStatus && (
                      <i
                        class="fa fa-bell text-primary"
                        style={{ fontSize: 17 }}
                        aria-hidden="true"
                      >
                        {riderCount}
                      </i>
                    )}
                  </span>
                </Link>
                <ul>
                  {permission.includes("Riders") && (
                    <li>
                      <Link
                        className={`${path === "riders" ? "mm-active" : ""}`}
                        to="/riders"
                        onClick={() => {
                          localStorage.setItem("ridersapplied", "");
                        }}
                      >
                        All Technician
                      </Link>
                    </li>
                  )}

               
                  {permission.includes("Blocked Riders") && (
                    <li>
                      <Link
                        className={`${
                          path === "blocked-rider" ? "mm-active" : ""
                        }`}
                        to="/blocked-rider"
                        onClick={() => {}}
                      >
                        Blocked Technician
                      </Link>
                    </li>
                  )}
                  {permission.includes("Rider Map View") && (
                    <li>
                      <Link
                        className={`${
                          path === "Rider-View" ? "mm-active" : ""
                        }`}
                        to="/Rider-View"
                      >
                        Technician Map View
                      </Link>
                    </li>
                  )}
               
                </ul>
              </li>
            )}

            {(permission.includes("AllOrders") ||
            
              permission.includes("All Analytics")) && (
              <li className={`${order.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  {" "}
                  <i>
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACBElEQVRIie2Wv4sTQRTHPzN7ETYg2HrgEWwsYjPJ7hZ3Nuktrpdod3+CnDbxB1jfv3DXWNgIClZyCP6A3QlbxUokeN7VNrJB2RkLsxDO3ctOkgMFv9Xu2/feZ957w84IHDUajS5MJpPH1to+YIED3/cH7Xb7h0ueNVdwlmWPgLszpt0syyxw3yWPdAUDfQBjzJa19sbUdsc1iSgznmrn5TKfAiqEeFuR+4QzxlDa6pJ2/rniamChdc4YQ1Wr+wBSys0gCEQQBAL4OgcEcFT4G2O2prbSMVSB1wE6nc6HwmCt3ZkDPxJC7BQvURS9n811WrV3dRiGr4Ardf3naZFd/W+DnX8gZUrTtJXn+UtgTQhxs9vtfpoXs5KKjTHbQBu4Zq19USdmqYrTNG0BKKX2kiS5JIQYAD/PFTxt7+H0uaeUejAcDr9JKZ+fG1hrvZHn+WugBZDn+ZskSXrdbnevbg7nGWutN4BD4Kpr7MLgCugXa20vDMPP5wJeJRQcZmyMuSilnF3o2PO8nlJq7AoFh4qjKBrx+6gcLwuFmhVrre95nvdUKfUsjuOPjUbj+zLQ2mDgljFGAE+mlS+tWuAgCK6vAjarv+5YPAGI43hz0cRJkhRXn+Oy71WtPgB2pZTvtNaLsgGw1u7XBvu+P8iyDOA2FXemGjq21u43m82HC8b/12r0C5c/xggGgvkKAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Order List</span>
                </Link>
                <ul>
                  {(permission.includes("AllOrders") ||
                    permission.includes("Order Ratings")) && (
                    <li>
                      <Link
                        className={`${
                          path === "all-orders" ? "mm-active" : ""
                        }`}
                        to="/all-orders"
                      >
                        All Orders
                      </Link>
                    </li>
                  )}
              
                  {permission.includes("All Analytics") && (
                    <li>
                      <Link
                        className={`${
                          path === "All-Analytics" ? "mm-active" : ""
                        }`}
                        to="/All-Analytics"
                      >
                        Order Analytics
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {(permission.includes("All Staff") ||
              permission.includes("Roles")) && (
              <li className={`${staff.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACrElEQVRIie2Uz0sUYRzGP9/ZccE6eJAISsq8WIdEdl7dZbVOHbxU0EGoayF0MLJLRXazPERd6lBBBy8SZkH4F5Qlus6ERb8oMkwLLwYVEaw7frtsoLPvtKZ2KHyOz/N9n887M++8sK7/XfInw6OjozWu63YBbcD2ov1ERC55njf0V8Dj4+MHRKQf2BgzMqiqp5uamiZXBR4YGEjU1dVdAY4AlUASqAAGVPWyiDwHNgDHgIvFru9ACOSB/snJyVPt7e3hssFBELSrajewOxJdN8Ycj877vr9TRK6q6r5I9AzoMcbcKQsufsf3gBuJwjAMN6fT6TnbZicmJrYWCoUpIBGJ5h3HqU2lUp8Wm060wHXdNgsU4EMcFKCxsfEj8NYSVYRh2BY1S8BAdUz3tzjoIuVtpohsKgsWEduuAepHRkYq44jFrD4G/KYsWFUXYrqnstnsjzhwMZuyZaqqZcEikozprg2CIBMHLmY7YuKKsuBUKjUI9FkWJ1X1hqra3pKjqjdtAKDP87y7ZcEislAoFLqBWUtJQxAEPVEzCIILlP7zALOu654TkZLPZzvVZDKZGaDVlgFnLd6ZmNnW4m9WIisYwBjzLi5brn7XYQWrqvi+fyJmzQuL99I26Pt+p6par+UlZi6Xa0okEgdV9RCwa1E0DzxS1aEwDG9lMpmvEUAVcBTYD7Sw9JC9EpF7YRjeb25uHl8CDoJgj6peAxoiG5tR1R4RuW2M+WLbueUpq4DDwHlgSyR+KiKdnucNSy6XyzqO84DS+/l1Pp9vyWazn5cDjGpsbKw6kUg8pvQ2KziOs9cRkV4LFBE5uVIoQDqdnlPVLkvkqmqvIyLGtlBVh1cK/aVkMvkwptuUnDjf96eBmtVCI5o2xmxbbNiuvw5gZi2hItKxhn3r+kf0E8hi9OOpoD2gAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Staff</span>
                </Link>
                <ul>
                  {permission.includes("All Staff") && (
                    <li>
                      <Link
                        className={`${path === "all-staff" ? "mm-active" : ""}`}
                        to="/all-staff"
                      >
                        All Staff
                      </Link>
                    </li>
                  )}
                  {permission.includes("Roles") && (
                    <li>
                      <Link
                        className={`${path === "all-roles" ? "mm-active" : ""}`}
                        to="/all-roles"
                      >
                        Roles
                      </Link>
                    </li>
                  )}
              
                </ul>
              </li>
            )}
          </MM>
        )}
        <div className="copyright">
          <p>
            <strong>Go Sampl Admin Dashboard</strong> ©{" "}
            {new Date().getFullYear()} All Rights Reserved
          </p>
          <p className="fs-12">
            Made with <span className="heart"></span> by Go Sampl
          </p>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
